import qs from 'qs';
import { ISuggestionType, IItemSuggestion, IItemFilter, IItemSuggestionList } from '../types';

export const createItemPath = (suggestion: IItemSuggestion): string[] => {
  const path = ['/snow'];
  if (suggestion) {
    const { id } = suggestion;
    switch (suggestion.type) {
      case 'resort':
        path.push(`/resorts/${id}/items`);
        break;
      case 'prefecture':
        path.push(`/searches/prefecture/${id}`);
        break;
      case 'area':
        path.push(`/searches/area/${id}`);
        break;
      default:
    }
  } else {
    path.push('/searches');
  }
  return path;
}

export const createItemParams = (type: ISuggestionType|null, filter: IItemFilter) => {
  const params = {};
  if (type === 'resort') {
    switch (filter) {
      case 'lift':
        params['type_lift'] = true; break;
      case 'lesson':
        params['type_lesson'] = true; break;
      case 'rental':
        params['type_rental'] = true; break;
      default:
    }
  } else if (type === 'prefecture' || type === 'area' || type == null) {
    const orderable = [];
    switch (filter) {
      case 'lift':
        orderable.push('type_lift'); break;
      case 'lesson':
        orderable.push('type_lesson'); break;
      case 'rental':
        orderable.push('type_rental'); break;
      default:
    }
    params['orderable'] = orderable;
  }
  return params;
}

export const stringifyItemParams = (params: any) => {
  return qs.stringify(params, { arrayFormat: 'brackets' });
}

export const defaultItemCount = () => {
  /* --- FIXME: バックエンドから取得する --- */
  return { lift: 100, lesson: 15, rental: 50 };
}

export const defaultItemSuggestionList: IItemSuggestionList = {
  resort: [],
  prefecture: [],
  area: [],
};
